import { render, staticRenderFns } from "./tumorStart.vue?vue&type=template&id=3b326331&scoped=true"
import script from "./tumorStart.vue?vue&type=script&lang=js"
export * from "./tumorStart.vue?vue&type=script&lang=js"
import style0 from "./tumorStart.vue?vue&type=style&index=0&id=3b326331&prod&scoped=true&lang=css"
import style1 from "./tumorStart.vue?vue&type=style&index=1&id=3b326331&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b326331",
  null
  
)

export default component.exports